/*
 * Copyright (C) Fraunhofer IESE 2021-2024 - Pedram (Majid) Jokar, Mher Ter-Tovmasyan,
 * Bestin John, Steffen Hupp, Anna Kleiner, Rafael Aranda Lopez King, Emily Calvet, Philipp Ewen,
 * Matthias Gerbershagen, Milad Chatrangoon, Stefan Schweitzer
 *
 * SPDX-License-Identifier: AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <https://www.gnu.org/licenses/>.
 */

import { whitelabelTextsDe } from 'config/texts';
import { APP_NAME } from 'settings';
import {
  administrationDashboardPage,
  administrationOffersPage,
  administrationOrganizationsPage,
  administrationPage,
  administrationUsersPage
} from './administrationPage';
import { chooseOrganizationPage } from './chooseOrganizationPage';
import { invitationsPage } from './invitationsPage';
import { draftPage } from './onboarding/draftPage';
import { requestsPage } from './onboarding/requestsPage';
import { organizationsPage } from './organizationsPage';
import { profilePage } from './profilePage';
import { toasts } from './toasts';

export const de = {
  appName: APP_NAME,
  profile: 'Profil',
  organizations: 'Organisationen',
  requests: 'Anfragen',
  solutions: 'Lösungen',
  invitations: 'Einladungen',
  legal: 'Rechtliches',
  email: 'E-Mail',
  solutionBar: {
    backToSolutionWithName: 'Zurück zu "{{solutionName}}"',
    backToSolutionWithoutName: 'Zurück zur Lösung'
  },
  navigation: {
    start: 'Startseite',
    subdomains: {
      book: 'Buchen',
      rent: 'Vermieten',
      profile: 'Profil',
      about: 'Über',
      administration: 'Administration'
    },
    titles: {
      start: 'Zur Startseite navigieren',
      book: 'Zur Buchung navigieren',
      rent: 'Zur Vermietung navigieren',
      about: 'Zur Über-Seite navigieren',
      administration: 'Zur Administration navigieren'
    }
  },
  navBar: {
    logout: 'Abmelden',
    bookings: 'Buchungen',
    bookingRequests: 'Buchungsanfragen'
  },
  error: {
    title: 'Hoppla, etwas lief schief!',
    noResponse: 'Der Server reagiert nicht.\nBitte versuch es später erneut.',
    options:
      'Wir schauen uns das Problem umgehend an. Falls du Hilfe benötigst oder Fragen hast, wende dich gerne ans <0>{{appName}} Support Team</0>!',
    toHome: 'Zur Startseite',
    toLandingPage: 'Zu {{appName}}',
    toOrganizations: 'Zur Organisationen'
  },
  form: {
    apply: 'Übernehmen',
    mandatoryField: '*Pflichtfeld',
    counter: '{{count}} / {{maxCount}} Zeichen',
    maxCharLengthError:
      'Maximale Zeichenlänge überschritten. Bitte kürze den Text.'
  },
  accessibility: {
    appURLLabel: 'Zurück zur Profilseite',
    navigateToLabel: 'Navigiere zur URL:',
    navigateBackLabel: 'Zurück zur vorherigen Seite',
    fallbackImageAlt: 'Platzhalter Bild (Original konnte nicht geladen werden)',
    profilePictureAlt: 'Profilbild',
    accordion: {
      deleteButtonLabel: 'Lösch-Taste',
      dragButtonLabel: 'Ziehen-Taste'
    },
    menuToggleLabel: 'Optionen'
  },
  footer: {
    language: {
      title: 'Sprache'
    },
    links: {
      title: 'Nützliche Links',
      privacyPolicy: 'Datenschutzhinweise',
      termsOfUse: 'Allgemeine Geschäftsbedingungen',
      imprint: 'Impressum',
      accessibility: 'Barrierefreiheit',
      easyLanguage: 'Leichte Sprache'
    },
    help: {
      title: 'Fragen & Hilfe',
      contactUs: 'Kontaktiere uns gerne.',
      lookingForward: 'Wir freuen uns schon!',
      contact: 'Kontakt',
      support: 'Support',
      faq: 'FAQ'
    },
    project: whitelabelTextsDe.footer.fundingNotice,
    bmleh: 'Förderhinweis Logo'
  },
  toasts,
  profilePage,
  organizationsPage,
  chooseOrganizationPage,
  invitationsPage,
  draftPage,
  requestsPage,
  administrationPage,
  administrationDashboardPage,
  administrationUsersPage,
  administrationOrganizationsPage,
  administrationOffersPage
};
